import { ICustomZoomLevels, IZoomLevels } from '../types'
import { zoomLevel0, zoomLevel1, zoomLevel2 } from './constants'

export const getZoomLevel = (zoomScale: number, customZoomLevels: ICustomZoomLevels): IZoomLevels => {
    if (customZoomLevels && customZoomLevels.level0 && customZoomLevels.level1 && customZoomLevels.level2) {
        if (zoomScale <= customZoomLevels.level0[1]) {
            return 'level0'
        } else if (zoomScale >= customZoomLevels.level1[0] && zoomScale <= customZoomLevels.level1[1]) {
            return 'level1'
        } else if (zoomScale >= customZoomLevels.level2[0] && zoomScale <= customZoomLevels.level2[1]) {
            return 'level2'
        }
    } else {
        if (zoomScale <= zoomLevel0[1]) {
            return 'level0'
        } else if (zoomScale >= zoomLevel1[0] && zoomScale <= zoomLevel1[1]) {
            return 'level1'
        } else if (zoomScale >= zoomLevel2[0] && zoomScale <= zoomLevel2[1]) {
            return 'level2'
        }
    }
}
